import { createPlatformStyles, theme } from "../../theme/theme";

export const { styles, ids } = createPlatformStyles({
  mobile: {
    contentContainer: {
      flex: 1,
      display: "flex",
      height: "100%",
      width: "110%",
    },
    container: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    backgroundImage: {
      width: "100%",
      height: "100%",
      position: "absolute",
    },
    errorView: {
      zIndex: 999,
      bottom: 0,
      height: "100%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
    },
    loader: {
      display: "flex",
      flex: 1,
      backgroundColor: `${theme.colors.black}50`,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: "110%",
    },
  },
  web: {
    contentContainer: {
      flex: 1,
      display: "flex",
      height: "100%",
      width: "100%",
    },
    container: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
    },
    gradientBg: {
      backgroundImage: theme.colors.backgroundGradient,
    },
    backgroundImage: {
      width: "100%",
      height: "100%",
      position: "absolute",
      objectFit: "cover",
    },
    errorView: {
      zIndex: 999,
      bottom: 0,
      height: "100%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
    },
    loader: {
      display: "flex",
      flex: 1,
      backgroundColor: `${theme.colors.black}50`,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
});
